$( document ).ready(function() {
let el = $('.after-footer-wrapper .secure-image-selector:first').html();
//$('.after-footer-wrapper .secure-image-selector:first').html('');
$('.after-footer-wrapper .secure-image-selector:first').html('<a href="//www.shopify.com.au/pci-compliant">'+el+'</a>');

let el2 = $('.after-footer-wrapper .secure-image-selector:last').html();
//$('.after-footer-wrapper .secure-image-selector:last').html('');
$('.after-footer-wrapper .secure-image-selector:last').html('<a href="//www.shopify.com/?ref=empower-digital">'+el2+'</a>');

  $("a.fancybox").fancybox({
		'hideOnContentClick': true
	});
});